var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoCamera24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.00057L16 3.00107L17.8298 5.00122L20.9998 5.00148C22.0998 5.00157 22.9998 5.90164 22.9997 7.00164L22.9987 19.0016C22.9986 20.1016 22.0985 21.0016 20.9985 21.0015L4.99852 21.0002C3.89852 21.0001 2.9986 20.1 2.99869 19L2.99967 7C2.99976 5.9 3.89984 5.00007 4.99984 5.00016L8.16984 5.00042L10 3.00057ZM16.9497 7.00114L15.1198 5.00099L10.8798 5.00065L9.04967 7.0005L4.99967 7.00016L4.99869 19.0002L20.9987 19.0015L20.9997 7.00148L16.9497 7.00114ZM12.9994 10.0008C14.6494 10.001 15.9993 11.3511 15.9992 13.0011C15.999 14.6511 14.6489 16.001 12.9989 16.0008C11.3489 16.0007 9.99905 14.6506 9.99918 13.0006C9.99932 11.3506 11.3494 10.0007 12.9994 10.0008ZM7.99918 13.0004C7.99941 10.2404 10.2396 8.00059 12.9996 8.00082C15.7596 8.00105 17.9994 10.2412 17.9992 13.0012C17.999 15.7612 15.7588 18.001 12.9988 18.0008C10.2388 18.0006 7.99895 15.7604 7.99918 13.0004Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoCamera24Px);
export default __webpack_public_path__ + "static/media/photo_camera_24px.40195e4b187ff93182f7d7029b4f6c85.svg";
export { ForwardRef as ReactComponent };